(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tt-feeding-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tt-feeding-calculator')) {
    class TTFeedingCalculator extends HTMLElement {
      connectedCallback() {
        this.weightEl = this.querySelector('[data-tt-weight]');
        this.stageEl = this.querySelector('[data-tt-stage]');
        if (!this.weightEl || !this.stageEl) return;
        this.weightEl.addEventListener('input', () => this.update());
        this.stageEl.addEventListener('change', () => this.update());
        this.update();
      }
      set(name, value) {
        const el = this.querySelector('[data-tt-' + name + ']');
        if (el) el.textContent = value;
      }
      update() {
        const w = Math.min(100, Math.max(0, Number(this.weightEl.value) || 0));
        const stage = this.stageEl.value;
        const puppy = stage !== 'adult';
        const lo = puppy ? 0.04 : 0.02;
        const hi = puppy ? 0.06 : 0.03;
        const meals = stage === 'puppy_young' ? 3 : 2;
        const r5 = (g) => Math.round(g / 5) * 5;
        const lowG = r5(w * 1000 * lo);
        const highG = r5(w * 1000 * hi);
        this.set('pct', puppy ? '4 to 6%' : '2 to 3%');
        this.set('w', String(w));
        this.set('low', String(lowG));
        this.set('high', String(highG));
        this.set('meals', String(meals));
        this.set('lowmeal', String(r5(lowG / meals)));
        this.set('highmeal', String(r5(highG / meals)));
        this.set('weeklow', (lowG * 7 / 1000).toFixed(1));
        this.set('weekhigh', (highG * 7 / 1000).toFixed(1));
        this.set('trayslow', String(Math.ceil(lowG * 7 / 500)));
        this.set('trayshigh', String(Math.ceil(highG * 7 / 500)));
      }
    }
    customElements.define('tt-feeding-calculator', TTFeedingCalculator);
  }
  } catch(e) { console.error(e); }
})();

})();
